import { render, staticRenderFns } from "./ScrollLoader.vue?vue&type=template&id=6a2aa4dc&scoped=true"
import script from "./ScrollLoader.vue?vue&type=script&lang=js"
export * from "./ScrollLoader.vue?vue&type=script&lang=js"
import style0 from "./ScrollLoader.vue?vue&type=style&index=0&id=6a2aa4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2aa4dc",
  null
  
)

export default component.exports